export enum InspectionStatus {
  Created = 1,
  Started = 2,
  Passed = 3,
  Failed = 4,
}

export function inspectionStatusLabel(id?: number | null): string {
  switch (id) {
    case InspectionStatus.Created: return 'Created';
    case InspectionStatus.Started: return 'Started';
    case InspectionStatus.Passed: return 'Passed';
    case InspectionStatus.Failed: return 'Failed';
    default: return id == null ? '—' : String(id);
  }
}

export function isInspectionStarted(id?: number | null): boolean {
  return !!id && id > InspectionStatus.Created;
}
